
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publica",
      function () {
        return require("private-next-pages/publica.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publica"])
      });
    }
  